import Swiper, {Autoplay, EffectCoverflow, EffectFade, Navigation, Pagination, Thumbs} from 'swiper';
import GLightbox from "glightbox";
import './profile-orders.js';

document.addEventListener("DOMContentLoaded", function (event) {

    // INIT MENUBUTTON
    const menu_button = document.querySelector('[data-behaviour="toggle-menu"]');
    menu_button.addEventListener('click', () => {
        document.body.classList.toggle('body--show');
    })

    var toggles = document.querySelectorAll('[data-behaviour="toggle-active"]');

    if (toggles.length)
        [...toggles].forEach((toggle) => {
            toggle.addEventListener("click", () => {
                toggle.parentNode.classList.toggle("section_nav--active");
            });
        })

    const deleteLinks = document.querySelectorAll('[data-behaviour="delete-link"]');
    deleteLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const confirmation = confirm(link.dataset.description || "Are you sure you want to delete this item?");
            if (confirmation) {
                this.location.href = link.href;
            }
        });
    });

    const brandSelect = document.querySelector('[data-behaviour="brand-select"]');
    if (brandSelect) {
        brandSelect.addEventListener('change', function () {
            const brandID = this.value;
            const baseURL = this.dataset.baseUrl || window.location.origin;
            const currentURL = new URL(baseURL);
            if (brandID) {
                currentURL.searchParams.set('BrandID', brandID);
                const selectedOption = this.options[this.selectedIndex];
                const sortOrder = selectedOption.dataset.sortOrder;
                if (sortOrder) {
                    currentURL.searchParams.set('SortOrder', sortOrder);
                }
            } else {
                currentURL.searchParams.delete('BrandID');
                currentURL.searchParams.delete('SortOrder');
            }
            window.location.href = currentURL.toString();
        });
    }

    const localeSelect = document.querySelector('[data-behaviour="locale-select"]');
    if (localeSelect) {
        localeSelect.addEventListener('change', function () {
            window.location.href = this.value;
        });
    }

    // INIT LIGHTBOX
    const lightbox = GLightbox({
        selector: '[data-gallery="gallery"]',
        touchNavigation: true,
        loop: true,
    });

    // INIT SWIPER
    const sliders = document.querySelectorAll('.swiper');
    sliders.forEach(function (slider) {
        const autoSwiper = slider.classList.contains('swiper--auto');
        const thumbnails = slider.parentNode.querySelector('.gallery-thumbs');
        var galleryThumbs = new Swiper(thumbnails, {
            spaceBetween: 10,
            slidesPerView: 4,

            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        const swiper = new Swiper(slider, {
            // configure Swiper to use modules
            modules: [Pagination, Navigation, Autoplay, EffectFade, Thumbs],
            effect: 'slide',
            fadeEffect: {
                crossFade: true
            },
            direction: 'horizontal',
            loop: true,

            autoplay: autoSwiper ? {
                delay: 5000,
            } : false,

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },

            thumbs: {
                swiper: galleryThumbs,
                autoScrollOffset: 1,
            },
        });
    });

    // FIXED HEADER
    window.addEventListener('scroll', () => {
        if (document.documentElement.scrollTop > 30 || document.body.scrollTop > 30){
            document.body.classList.add('menu--fixed');
        } else {
            document.body.classList.remove('menu--fixed');
        }
    });

    // QUANTITY CALCULATOR
    const quantityCalculator = document.querySelector('[data-behaviour="quantity-calculator"]');
    if (quantityCalculator) {
        const alreadyOrdered = quantityCalculator.dataset.alreadyordered || 0;
        const singlepricedisplay = quantityCalculator.querySelector('[data-behaviour="quantity-calculator-singleprice"]');
        const totalpricedisplay = quantityCalculator.querySelector('[data-behaviour="quantity-calculator-totalprice"]');
        const amountInput = quantityCalculator.querySelector('input');
        const pricelistentries = document.querySelectorAll('[data-behaviour="pricelist-entry"]');
        const baseprice = quantityCalculator.dataset.baseprice || 0;

        // Parse price list into array of {quantity, price}
        let priceList = [];
        priceList.push({quantity: 1, price: baseprice});
        pricelistentries.forEach(entry => {
            const quantity = parseInt(entry.querySelector('[data-behaviour="pricelist-entry-amount"]').textContent, 10);
            let priceText = entry.querySelector('[data-behaviour="pricelist-entry-price"]').textContent;
            priceText = priceText.replace('€', '').replace(/\s/g, '').replace(',', '.');
            const price = parseFloat(priceText);
            priceList.push({quantity, price});
        });
        // Sort priceList by quantity ascending
        priceList.sort((a, b) => a.quantity - b.quantity);

        function getSinglePrice(amount) {
            // Find the highest quantity <= amount
            let applicable = priceList[0];
            //Add the alreadyordered to the amount
            amount += parseInt(alreadyOrdered, 10) || 0;
            for (let i = 0; i < priceList.length; i++) {
                if (amount >= priceList[i].quantity) {
                    applicable = priceList[i];
                } else {
                    break;
                }
            }
            return applicable.price;
        }

        function updatePriceDisplay(quantity) {
            let singlePrice = getSinglePrice(quantity);
            let totalPrice = singlePrice * quantity;

            //If singleprice does not include cents, add them
            if (!singlePrice.toString().includes('.')) {
                singlePrice = singlePrice + ".00";
                totalPrice = totalPrice + ".00";
            }

            //Limit the prices to max 2 decimals
            const formatter = new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            singlePrice = formatter.format(parseFloat(singlePrice));
            totalPrice = formatter.format(parseFloat(totalPrice));

            singlepricedisplay.textContent = singlePrice + " €";
            totalpricedisplay.textContent = totalPrice + " €";
        }

        // Initial display
        updatePriceDisplay(parseInt(amountInput.value, 10) || 0);

        // Update on input change
        amountInput.addEventListener('input', function() {
            const quantity = parseInt(this.value, 10) || 0;
            updatePriceDisplay(quantity);
        });
    }


    //INDIVIDUAL ORDER FILTER
    const individualOrderFilter = document.querySelector('[data-behaviour="existingIndividualOrders_filter"]');
    const individualOrderList = document.querySelector('[data-behaviour="existingIndividualOrders_list"]');
    if (individualOrderFilter && individualOrderList) {
        const titleInput = individualOrderFilter.querySelector('input[name="Product"]');
        const brandSelect = individualOrderFilter.querySelector('select[name="BrandID"]');
        const sortSelect = individualOrderFilter.querySelector('select[name="SortOrder"]');
        const listEntries = individualOrderList.querySelectorAll('[data-behaviour="list_entry"]');

        function filterAndSortEntries() {
            const titleFilter = titleInput.value.toLowerCase();
            const brandFilter = brandSelect.value;
            const sortOrder = sortSelect.value;

            let entriesArray = Array.from(listEntries);

            // Filter by title and brand
            entriesArray = entriesArray.filter(entry => {
                const title = entry.dataset.title.toLowerCase();
                const brandID = entry.dataset.brandid;
                const matchesTitle = title.includes(titleFilter);
                const matchesBrand = !brandFilter || brandID === brandFilter;
                return matchesTitle && matchesBrand;
            });

            // Sort entries
            entriesArray.sort((a, b) => {
                if (sortOrder === 'Created DESC') {
                    return new Date(b.dataset.created) - new Date(a.dataset.created);
                } else if (sortOrder === 'Created ASC') {
                    return new Date(a.dataset.created) - new Date(b.dataset.created);
                } else {
                    return 0;
                }
            });

            // Clear current list
            individualOrderList.innerHTML = '';

            // Append filtered and sorted entries
            entriesArray.forEach(entry => {
                individualOrderList.appendChild(entry);
            });
        }

        // Initial filter and sort
        filterAndSortEntries();

        // Event listeners for filter inputs
        titleInput.addEventListener('input', filterAndSortEntries);
        brandSelect.addEventListener('change', filterAndSortEntries);
        sortSelect.addEventListener('change', filterAndSortEntries);
    }

    var _paq = window._paq = window._paq || [];
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    (function() {
        var u="https://matomo.atw.io/";
        _paq.push(['setTrackerUrl', u+'matomo.php']);
        _paq.push(['setSiteId', '49']);
        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
        g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
    })();
});
